import api from '../common/utils/api.js';

export function post(path) {
  return (data) =>
    api({
      method: 'Post',
      path,
      data
    });
}

export const auth = post('netlify-addon/auth');
export const claim = post('netlify-addon/claim');
